import React from 'react'
import SearchBarView from 'components/SearchBarView'
import { createUrlIdc, cleanString } from 'utils/utils'
import { config } from 'config/config.js'
import './SearchBar.scss'

export default class MakeModelSearchBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      inputValue: '',
      openResults: false,
      result: undefined,
    }
    this.maxResults = 5
    this.timeout = undefined
    this.searchDelay = 500
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.inputValue &&
      this.state.inputValue != prevState.inputValue
    ) {
      this.timeout && clearTimeout(this.timeout)
      this.timeout = setTimeout(
        function () {
          this.setState({ result: this.renderResults() })
        }.bind(this),
        this.searchDelay
      )
    }
    if (this.props.vehicleType != prevProps.vehicleType) {
      this.resetSearch()
    }
  }

  resetSearch() {
    this.handleInputChange('')
    this.setState({ result: undefined })
  }

  contains(string, substring) {
    let regex = new RegExp(/([\s\_]+)/)
    let resultArr = substring.split(regex)
    for (let i = 0; i < resultArr.length; i++) {
      if (
        resultArr[i].trim().length &&
        cleanString(resultArr[i], { toLowerCase: 1, removeAccents: 1 }) != ''
      ) {
        if (
          !cleanString(string, { toLowerCase: 1, removeAccents: 1 }).includes(
            cleanString(resultArr[i], { toLowerCase: 1, removeAccents: 1 })
          )
        ) {
          return false
        }
      }
    }
    return true
  }

  renderResultEntry(name, img, url) {
    return { name: name, url: url, img: img }
  }

  mergeUrls(url1, url2) {
    const queryStringToObject = string => {
      if (string === '') return {}
 
      const params = string.replace('?', '').split(`&`)
      const obj = {}
 
      for (let param of params) {
        const [key, value] = param.split('=')
 
        obj[decodeURI(key)] = decodeURI(value)
      }
 
      return obj
    }
 
    // Extrair a marca da segunda URL
    const regexMarca = /marca1=([^&]+)/
    const matchMarca = regexMarca.exec(url2)
    const regexModelo = /modelo1=([^&]+)/
    const matchModelo = regexModelo.exec(url2)
 
    if (!matchMarca) {
      return url1 // Retorna a URL original se não conseguir extrair a marca
    }
 
    // Salva a marca extraída e verifica se o modelo foi encontrado
    const marca = matchMarca[1]
    const modelo = matchModelo ? matchModelo[1].toLowerCase() : null
    const marcaEModelo = [marca.toLowerCase()]
    if (modelo) {
      marcaEModelo.push(modelo)
    }
 
    const url = new URL(`https://webmotors.com.br${url1}`)
    const urlParts = url.pathname.split('/').filter(part => Boolean(part)) // ['carros', 'localizacao', 'marca', 'modelo', ...rest]
 
    let startUrl = []
    let endUrl = []
 
    if (url1.includes('/ofertas/feiroes')) {
      const [ofertas, feiroes, feirao, tipo, localizacao, ...urlRest] = urlParts;
   
     
      startUrl = [ofertas, feiroes, feirao, tipo, localizacao]
      endUrl = urlRest
    }  else {
      const [tipo, localizacao = 'estoque', ...urlRest] = urlParts // carros, sp ou estoque
 
      startUrl = [tipo, localizacao]
      endUrl = urlRest
    }
    const parts = endUrl.filter(
      part => part.startsWith('.ate') || part.startsWith('.de')
    )
 
    const novaUrl = [...startUrl, ...marcaEModelo, ...parts].filter(item => !!item).join('/')
 
    const url1Params = new URL(`https://webmotors.com.br${url1}`).search
    const url2Params = new URL(`https://webmotors.com.br${url2}`).search
 
    const url1ParamsObj = queryStringToObject(url1Params)
 
    delete url1ParamsObj.modelo1
    delete url1ParamsObj.versao1
 
    const queryString = {
      ...url1ParamsObj,
      ...queryStringToObject(url2Params),
    }
 
    let novaQueryString = []
 
    for (const key in queryString) {
      novaQueryString.push(`${key}=${encodeURI(queryString[key])}`)
    }
 
    return `/${novaUrl}?${novaQueryString.join('&')}`
  }

  renderResults() {
    let makes = []
    let models = []
    let searchResults = this.props.search.source.result
    let locationLeft = this.props.locationLeft || 'estoque'
    let locationRight = this.props.locationRight || 'estoque'

    for (let makeIndex = 0; makeIndex < searchResults.length; makeIndex++) {
      let makeName = searchResults[makeIndex].name
      let makeLink =
        '/' +
        this.props.vehicleRoute +
        '/' +
        locationLeft +
        '/' +
        cleanString(searchResults[makeIndex].name, {
          toLowerCase: 1,
          removeAccents: 1,
          removeDots: 1,
          slugify: 1,
        }) +
        '?estadocidade=' +
        locationRight +
        '&marca1=' +
        encodeURIComponent(searchResults[makeIndex].name)
      makeLink =
        createUrlIdc(
          makeLink,
          undefined,
          'marca',
          cleanString(makeName, { toLowerCase: 1, removeAccents: 1 })
        ) +
        '&autocomplete=' +
        this.state.inputValue +
        '&autocompleteTerm=' +
        makeName
      makeLink = this.mergeUrls(
        `${location.pathname}${location.search}`,
        makeLink
      )
      let makeImg =
        config.makeLogoCatalogo +
        (this.props.vehicleType == 'car' ? 'carro/' : 'moto/') +
        cleanString(makeName, { toLowerCase: 1, removeAccents: 1 }) +
        '.png?t=' +
        config.randomUrl
      if (this.contains(makeName, this.state.inputValue)) {
        makes.push(this.renderResultEntry(makeName, makeImg, makeLink))
      }

      for (
        let modelIndex = 0;
        modelIndex < searchResults[makeIndex].items.length;
        modelIndex++
      ) {
        let modelName =
          searchResults[makeIndex].name +
          ' ' +
          searchResults[makeIndex].items[modelIndex].name
        let modelImg = ''
        let modelLink =
          '/' +
          this.props.vehicleRoute +
          '/' +
          locationLeft +
          '/' +
          cleanString(searchResults[makeIndex].name, {
            toLowerCase: 1,
            removeAccents: 1,
            removeDots: 1,
            slugify: 1,
          }) +
          '/' +
          cleanString(searchResults[makeIndex].items[modelIndex].name, {
            toLowerCase: 1,
            removeAccents: 1,
            removeDots: 1,
            slugify: 1,
          }) +
          '?estadocidade=' +
          locationRight +
          '&marca1=' +
          encodeURIComponent(searchResults[makeIndex].name) +
          '&modelo1=' +
          encodeURIComponent(searchResults[makeIndex].items[modelIndex].name)
        modelLink =
          createUrlIdc(
            modelLink,
            undefined,
            'modelo',
            cleanString(modelName, { toLowerCase: 1, removeAccents: 1 })
          ) +
          '&autocomplete=' +
          this.state.inputValue +
          '&autocompleteTerm=' +
          modelName

        modelLink = this.mergeUrls(
          `${location.pathname}${location.search}`,
          modelLink
        )

        if (this.contains(modelName, this.state.inputValue)) {
          models.push(this.renderResultEntry(modelName, modelImg, modelLink))
        }
      }
    }
    let resultsLeft = this.maxResults

    if (resultsLeft) {
      makes = makes.slice(0, resultsLeft)
      resultsLeft -= makes.length
      makes = makes.length ? { title: 'Marcas', result: makes } : undefined
    }

    if (resultsLeft) {
      models = models.slice(0, resultsLeft)
      resultsLeft -= models.length
      models = models.length ? { title: 'Modelos', result: models } : undefined
    } else {
      models = []
    }

    if (models == undefined && makes == undefined) {
      return this.renderResultUndefined()
    }

    let result = [makes, models]

    return result
  }

  renderResultUndefined() {
    return []
  }

  handleInputChange(value) {
    if (value.length > 1) {
      this.setState({
        inputValue: value,
        openResults: true,
      })
    } else {
      this.setState({
        openResults: false,
        inputValue: value,
      })
    }
  }

  focusCallback(value) {
    this.props.modalCallback && this.props.modalCallback(value)
  }

  render() {
    return (
      <SearchBarView
        responsive={this.props.responsive}
        placeholder={this.props.placeholder}
        focusCallback={this.focusCallback.bind(this)}
        className={this.props.className}
        fetchAutoComplete={this.props.fetchAutoComplete}
        compactIcon={this.props.compactIcon}
        inputValue={this.state.inputValue}
        openResults={this.state.openResults}
        inputValueCallback={this.handleInputChange.bind(this)}
        search={this.props.search}
        result={this.state.result}
      />
    )
  }
}
